define(
  'builderShowcaseGalleryImagesHandler',[
    'builderShowcaseHelper',
    'i18n!nls/res'
  ],
  (builderShowcaseHelper, language) => {
    'use strict';

    const videoThumbnailElement = document.getElementById('VideoThumbnail');
    const videoThumbnail = videoThumbnailElement.value;
    const brandName = document.querySelector('[data-brand-name]')
      ? document.querySelector('[data-brand-name]').value
      : document.querySelector('#NHS_BuilderShowCaseTitle').textContent;

    /**
     * Used to get the number of amenities by a plan.
     * @param {String} amenity the string containing the amenity, and quantity.
     * @returns an object that contains the amenity, and the quantity of said amenity.
     */
    function getAmenityNumber(amenity) {
      const number = amenity.substr(0, amenity.indexOf(' '));
      const name = amenity.substr(amenity.indexOf(' ') + 1).replace(' ', '');

      return {
        number,
        name
      };
    }

    /**
     * @private
     * Used to get the image
     * @param {*} element the figure element
     * @param {*} image the image object
     */
    function addImageAmenities(element, image) {
      const amenities = image.Amenities;

      const list = amenities.map((amenity) => {
        const span = document.createElement('span');
        const attribute = getAmenityNumber(amenity);
        span.textContent = amenity + ' ';
        span.setAttribute(`data-${attribute.name}`, attribute.number);
        return span;
      });

      const amenitiesContainer = element.querySelector('p');

      list.forEach((amenity) => {
        amenitiesContainer.appendChild(amenity);
      });
    }

    /**
     * Used to add the title to the figure element
     * @param {*} element the figure element
     * @param {*} image the image object
     */
    function addTitle(element, image) {
      const title = image.PlanName;

      if (title) {
        const header = element.querySelector('strong');
        header.textContent = title;
      }
    }

    /**
     * Used to add the images to the figure element
     * @param {*} element the figure element
     * @param {*} image the image object
     */
    function addImages(element, image) {
      const sources = image.Sources;
      const thumbnail = image.ThumbnailSrcFormatedWithIrs;
      const img = element.querySelector('img');
      const template = element.querySelector('source');
      const sizes = template.sizes;
      const figCaption = element.querySelector('figcaption');

      if (figCaption) {
        figCaption.dataset.galleryItemId = image.Id;
        figCaption.dataset.galleryCollection = image.CollectionName;
        figCaption.dataset.planId = image.PlanId;
      }

      sources.forEach((source) => {
        const src = document.createElement('source');
        const url = source.replace('srcset=', '').replace(/"/g, '');
        src.sizes = sizes;
        src.srcset = url;
        src.type = builderShowcaseHelper.getImageType(url);

        template.parentElement.insertBefore(src, img);
      });

      template.parentElement.removeChild(template);

      if (thumbnail && img) {
        img.src = thumbnail;
        img.alt = `${image.CollectionName} ${language.from} ${image.PlanName} 
        ${language.plan} ${language.by} ${brandName}`;
      }

      if (image.CollectionName === 'Videos') {
        img.src = videoThumbnail;
      }
    }

    /**
     * @private
     * setGaAttribute: set event label to be log google analytics. Event Label change dynamic as user interacts
     * with the site.
     *
     * @param {Element} element current element to update the data-ga-event-label
     * @param {Object} data information of the current image.
     */
    function setEventLabelGA(element, data) {
      const figure = element;
      const amenities = data.Amenities || [];
      figure.dataset.gaEventLabel = `${data.PlanName || ''} + ${amenities.join('')}`;
    }

    /**
     * @private
     * Creates a new figure element to add to the gallery.
     * @param {*} template the template used to create a new figure.
     * @param {*} image the required data to create the new image.
     * @param {Number} index of current item.
     * @returns a new picture element.
     */
    function createGalleryItem(image, index) {
      const template = document.querySelector('[data-gallery-item-template]');
      const newElement = template.cloneNode(true);

      const figure = newElement.content.querySelector('figure');
      const parent = figure.querySelector('.gallery__figure-imgbox');

      if (parent && image.CollectionName === 'Videos') {
        parent.setAttribute('data-gallery-video', true);
      }
      addImageAmenities(figure, image);
      addTitle(figure, image);
      addImages(figure, image);
      setEventLabelGA(figure, image);
      figure.dataset.ga4EventClick_target1 = index + 1;

      return figure;
    }

    /**
     * @private
     * Used to create the new images to be displayed.
     */
    function createGallerySection(collection) {
      const images = collection.Items;
      const container = document.querySelector('[data-section-gallery-images]');

      images.forEach((image, index) => {
        const newElement = createGalleryItem(image, index);
        container.appendChild(newElement);
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
          // eslint-disable-next-line no-self-assign
          newElement.outerHTML = newElement.outerHTML;
        }
      });
    }

    return {
      createGallerySection
    };
  }
);

